"use client";

import { useSyncExternalStore } from "react";
import { DEFAULT_MODE, DEFAULT_THEME } from "../default-theme";
import { getMode, getTheme, setMode, setTheme, subscribeTheme } from "./client";

export function useThemeSettings() {
  const theme = useSyncExternalStore(subscribeTheme, getTheme, () => DEFAULT_THEME);
  const mode = useSyncExternalStore(subscribeTheme, getMode, () => DEFAULT_MODE);
  return { theme, mode, setTheme, setMode };
}
